
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"fill":"#0177FD","d":"M19.709 12.28l.124-.086a.274.274 0 00-.015-.467 3.602 3.602 0 00-2.161-.486 3.55 3.55 0 00-1.453.462c-.306-.546-.576-1.1-.812-1.629h.643a.444.444 0 00.445-.48c-.082-.896-.381-1.456-.63-1.775a.937.937 0 00-.74-.355h-.703a17.814 17.814 0 01-.195-.658.558.558 0 00-.655-.394c-.861.181-1.587.79-1.954 1.151-.172.17-.204.443-.047.625a.465.465 0 00.679.028c.195-.193.655-.61 1.19-.825.106.361.272.89.5 1.513h-1.374c-2.204 0-2.755 1.98-2.755 1.98H8.442a1.714 1.714 0 01-1.36-.667l-.072-.093a1.745 1.745 0 00-1.387-.68H3.875a.727.727 0 00-.733.676.726.726 0 00.733.764h1.88c2.02 0 3.123 1.44 3.123 1.44l-.761.413a2.954 2.954 0 00-2.18-.954c-1.62 0-2.937 1.292-2.937 2.88 0 1.588 1.318 2.88 2.938 2.88 1.497 0 2.733-1.102 2.915-2.52H9.98c2.02 1.26 4.04 0 4.04 0-.296-2.327.486-3.596.797-3.997.197.41.413.825.649 1.236-.44.435-.768.981-.93 1.595a3.335 3.335 0 00-.005 1.704.287.287 0 00.433.17c.1-.067.196-.137.293-.206a2.938 2.938 0 002.805 2.017c1.62 0 2.938-1.29 2.938-2.879 0-.99-.513-1.864-1.291-2.383zM5.938 16.463c-1.012 0-1.835-.808-1.835-1.8s.823-1.8 1.835-1.8c.449 0 .859.158 1.177.42l-1.23.67a.584.584 0 00-.301.384.57.57 0 00.565.686h1.589a1.831 1.831 0 01-1.8 1.44zm2.886-2.34a2.799 2.799 0 00-.148-.5l.845-.523s.15.656.265.995l.01.028h-.972zm9.238 2.34c-1.013 0-1.837-.808-1.837-1.8 0-.32.086-.619.235-.879.41.545.86 1.051 1.356 1.484a.47.47 0 00.664-.053c.159-.19.112-.474-.076-.64a9.04 9.04 0 01-1.294-1.449 1.86 1.86 0 01.952-.263c1.012 0 1.836.808 1.836 1.8s-.824 1.8-1.836 1.8z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z"}})])])
          )
        }
      }
    